import { PurchaseChannel } from "@redotech/redo-model/warranties";
import { RedoButton } from "@redotech/redo-web/arbiter-components/buttons/redo-button";
import {
  Layout,
  RedoCheckboxCard,
} from "@redotech/redo-web/arbiter-components/checkbox/redo-checkbox-card";
import { RedoTextInput } from "@redotech/redo-web/arbiter-components/input/redo-text-input";
import { Flex } from "@redotech/redo-web/flex";
import { LoadingRedoAnimation } from "@redotech/redo-web/loading-redo-animation";
import { Text } from "@redotech/redo-web/text";
import { memo } from "react";
import { Header } from "./header";
import * as loginStyles from "./login.module.css";
import { useRegister } from "./use-register";
export const Register = memo(function Register({
  channelFilter,
  isClaimOnly,
  onBack,
  toRetailRegistration,
  toOnlineRegistration,
}: {
  channelFilter?: PurchaseChannel;
  isClaimOnly?: boolean;
  onBack: (() => void) | undefined;
  toRetailRegistration: (channelName: string) => void;
  toOnlineRegistration: (channelName: string) => void;
}) {
  const {
    texts,
    purchaseChannelOptions,
    continueDisabled,
    isOtherOptionSelected,
    selectedPurchaseOptionId,
    otherPurchaseChannel,
    showLoading,
    setOtherPurchaseChannel,
    setSelectedPurchaseOptionId,
    onContinue,
  } = useRegister({
    toRetailRegistration,
    toOnlineRegistration,
    channelFilter,
    isClaimOnly,
  });
  if (showLoading) {
    return <LoadingRedoAnimation />;
  }
  return (
    <Flex className={loginStyles.cardContent} flexDirection="column" gap="3xl">
      <Header
        leftAlign
        logo={undefined}
        merchantName={texts.merchantName}
        onBack={onBack}
        subtitle={texts.subtitle}
        title={texts.title}
      />
      <Flex flexDirection="column" gap="lg">
        {purchaseChannelOptions.map((option) => (
          <RedoCheckboxCard
            checked={selectedPurchaseOptionId === option.id}
            inputSize="sm"
            inputType="radio"
            key={option.id}
            layout={Layout.LEFT}
            onClick={() => setSelectedPurchaseOptionId(option.id)}
            title={
              <Text fontSize="sm" fontWeight="regular" textColor="secondary">
                {option.label}
              </Text>
            }
          />
        ))}
        {isOtherOptionSelected && (
          <RedoTextInput
            label="Please specify"
            placeholder="Enter retailer name"
            setValue={setOtherPurchaseChannel}
            value={otherPurchaseChannel}
          />
        )}
      </Flex>
      <RedoButton
        disabled={continueDisabled}
        hierarchy="primary"
        onClick={onContinue}
        size="md"
        text={texts.continueButtonText}
      />
    </Flex>
  );
});
